import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ITheme } from '@homeviews/styles'
import { Typography, Button } from '@homeviews/shared-ui'
import { maybePlaceholderImage } from '@homeviews/utils'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    wrapper: {
      paddingTop: 5,
      paddingBottom: 5,
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #EBEBEB',
      borderRadius: 3,
      backgroundColor: '#FFFFFF',
      boxShadow: '1px 2px 6px 0 rgba(0,0,0,0.04)',
      overflow: 'hidden',
      padding: theme.spacing(2),
    },
    body: {
      flex: 1,
      display: 'flex',
      justifyContent: 'spacee-between',
      padding: theme.spacing(1.25, 2.5),
    },
    main: {
      flex: 1,
    },
    title: {
      marginBottom: theme.spacing(1.25),
    },
    meta: {
      display: 'flex',
      color: theme.colors.grey450,
      '& p': {
        fontSize: 16,
      },
      '& p:last-child': {
        marginLeft: 3,
      },
    },
    imageWrapper: {
      height: 75,
      width: 100,
      borderRadius: 3,
      position: 'relative',
      overflow: 'hidden',
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    removeButton: {
      alignSelf: 'center',
    },
  }),
)
interface IProps {
  className?: string
  id: number
  filename: string
  size?: number
  extension?: string
  url?: string
  onDelete?: (id: number) => void
}

const HorizontalCard: FC<IProps> = ({
  className,
  id,
  filename,
  size,
  extension,
  url,
  onDelete,
}) => {
  const classes = useStyles()

  const handleDeleteClick = () => {
    if (!onDelete) return
    onDelete(id)
  }

  return (
    <div className={classes.wrapper}>
      <div className={clsx(classes.root, className)}>
        <div className={classes.imageWrapper}>
          <img src={maybePlaceholderImage(url)} alt={`${filename}`} />
        </div>
        <div className={classes.body}>
          <div className={classes.main}>
            <Typography variant="h4" className={classes.title}>
              {filename}
            </Typography>
            <div className={classes.meta}>
              {!!size && <Typography>{size}kb |</Typography>}
              {!!extension && <Typography>{extension}</Typography>}
            </div>
          </div>
          <Button
            className={classes.removeButton}
            variant="outlined"
            customColor="red"
            onClick={handleDeleteClick}
          >
            Remove media
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HorizontalCard
